export default "__VITE_ASSET__304d4c6a__"